// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CatalogSorting{border-bottom:1px solid #d9d9d9;display:flex}.CatalogSorting__option{color:#606060;cursor:pointer;font-size:.8125rem;padding:.75rem 1rem}.CatalogSorting__option--active{background-color:#fff;border:1px solid #d9d9d9;border-bottom:none;border-top-color:#7cb342;margin-bottom:-1px}.CatalogSorting__option--active-first{border-left:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
